import { Component, ViewChild } from '@angular/core';

import { AlertTimerComponent } from '../alert-timer/alert-timer.component';
import { DialogComponent } from '../dialog/dialog.component';
import { AlertComponent } from '../alert/alert.component';
import { InformationComponent } from '../information/information.component';
import { OptionSelectorDialogComponent } from '../option-selector-dialog/option-selector-dialog.component';

@Component({
  selector: 'app-message',
  templateUrl: './message.component.html',
  styleUrls: ['./message.component.scss'],
  standalone: true,
  imports: [
    AlertComponent,
    AlertTimerComponent,
    InformationComponent,
    DialogComponent,
    OptionSelectorDialogComponent
  ]
})
export class MessageComponent {
  @ViewChild('alertTimer') alertTimer!: AlertTimerComponent;
  @ViewChild('dialog') dialog!: DialogComponent;
  @ViewChild('optionSelectorDialog') optionSelectorDialog!: OptionSelectorDialogComponent;

  constructor() {}

  closeAlertTimer(): void {
    this.alertTimer.cancelAlert();
  }

  closeDialog(): void {
    this.dialog.closeDialog(false);
  }
}
